import React from 'react';
import { PropsWithChildren } from "react"
import { TAccordionBodyProps } from "types/Components/Common/Accordion"

/**
 * Accordion body element 
 * use with combination of AccordionLayout
 * 
 * @param children
 * @returns 
 */
const AccordionBody = ({isOpen, children}: PropsWithChildren<TAccordionBodyProps>) => {
    if(!isOpen) return <></>

    return <div className={`tw-w-full`}>
            {children}
        </div>
}

export default AccordionBody